import Accordion from '../components/Accordion.jsx';
import PageHero from '../components/PageHero.jsx';
import SectionHeader from '../components/SectionHeader.jsx';
import { eventDateRange, wellnessDays } from '../content.js';

export default function WellnessWeek() {
  return (
    <>
      <PageHero label={`Transformational Wellness Week • ${eventDateRange}`} title="Five days. One community. Lasting impact." intro="A dynamic week of wellness, learning, connection, and celebration designed to uplift lives and strengthen communities." image="/assets/hero-community.jpg" imageAlt="San Francisco neighbors serving their community">
        <a className="button button--gold" href="#wellness-wednesday">Explore the five days</a>
      </PageHero>

      <section className="week-intro section-pad">
        <div className="shell week-intro__grid">
          <div><p className="overline">Strengthening bodies & minds</p><h2>An immersive experience from the inside out.</h2></div>
          <div><p>Transformational Wellness Week brings together holistic health programs, workshops and training, community connection, sustainable practices, and measurable impact that extends beyond the week.</p><p><strong>Together, we advocate. Together, we build. Together, we rise.</strong></p></div>
        </div>
      </section>

      <section className="week-days section-pad section-dark">
        <div className="shell">
          <SectionHeader light label={`The featured program • ${eventDateRange}`} title="Five days of purpose." body="Open any day for the complete schedule, audience, signature experiences, and presenting-partner opportunities from the program deck." />
          <div className="week-days__list">
            {wellnessDays.map((day, index) => (
              <article className="day-chapter" id={day.slug} key={day.slug}>
                <header className="day-chapter__header">
                  <span>{day.number}</span>
                  <div><p>{day.date} • {day.time}</p><h2>{day.name}</h2><h3>{day.theme}</h3></div>
                  <div className="day-chapter__attendance"><small>Expected attendance</small><strong>{day.attendance}</strong><span>{day.audience}</span></div>
                </header>
                <div className="day-chapter__body">
                  <div className="day-chapter__story">
                    <p>{day.intro}</p>
                    {day.practitioner ? <p><strong>{day.practitioner}</strong></p> : null}
                    {day.evening ? <p><strong>{day.evening}</strong></p> : null}
                    {day.extra ? <p>{day.extra}</p> : null}
                    {day.schedule ? <div><h4>Schedule notes</h4><ul>{day.schedule.map((item) => <li key={item}>{item}</li>)}</ul></div> : null}
                  </div>
                  <div><h4>Signature experiences</h4><ul>{day.experiences.map((item) => <li key={item}>{item}</li>)}</ul></div>
                </div>
                <Accordion title="Presenting-day partnership" meta={`${day.donation} presenting donation`} open={index === 0} className="accordion--dark">
                  <div className="partner-detail-grid">
                    <div><h4>Sponsor activation opportunities</h4><ul>{day.activation.map((item) => <li key={item}>{item}</li>)}</ul></div>
                    <div><h4>Branding opportunities</h4><ul>{day.branding.map((item) => <li key={item}>{item}</li>)}</ul></div>
                    <div><h4>{day.sponsorLine}</h4><p>{day.sponsorDescription}</p><a href="/contact">Start a conversation →</a></div>
                  </div>
                </Accordion>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="gala section-pad">
        <div className="shell gala__grid">
          <div><p className="overline">An evening of legacy</p><h2>K.E.E.N. Legacy Gala - SF</h2><p>One elegant evening of storytelling, recognition, global connection, culture, and unity. Together, we honor the people building healthier communities and commit to a future where impact lives for generations.</p></div>
          <div className="gala__details"><p><strong>Inspiring stories</strong> Transformation made possible through unity and compassion.</p><p><strong>Partner recognition</strong> Sponsors and changemakers whose generosity drives change.</p><p><strong>Global connections</strong> Relationships with leaders, philanthropists, and advocates.</p><p><strong>Culture & celebration</strong> Cambodian music, art, cuisine, and performances.</p><p><strong>Legacy in action</strong> A commitment to communities that thrive for generations.</p></div>
        </div>
      </section>

      <section className="centered-cta section-pad"><div className="shell narrow"><h2>A week of purpose. A lifetime of change.</h2><p>Your participation helps provide wellness services, education, resources, and experiences that strengthen communities.</p><a className="button button--gold" href="/contact">Join the movement</a></div></section>
    </>
  );
}
